// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reports_table_outer_container[data-v-081cf2c2]{overflow:auto}\n", ""]);
// Exports
module.exports = exports;
